import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { FormsModule } from '@angular/forms';
import { speechReducer } from '../store/reducers/speech.reducer';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ViewSpeechesComponent } from './view-speeches/view-speeches.component';
import { SubmitSpeechComponent } from './submit-speech/submit-speech.component';
import { SearchSpeechesComponent } from './search-speeches/search-speeches.component';
import { AddSpeechFormComponent } from './submit-speech/add-speech-form/add-speech-form.component';
import { AddAuthorFormComponent } from './submit-speech/add-author-form/add-author-form.component';
import { AuthorSvgComponent } from './components/author-svg/author-svg.component';
import { EmptySpeechComponent } from './components/empty-speech/empty-speech.component';

const routes: Routes = [
  { path: '', component: ViewSpeechesComponent },
  {
    path: 'submit',
    component: SubmitSpeechComponent,
  },
  {
    path: 'search',
    component: SearchSpeechesComponent,
  },
];

@NgModule({
  declarations: [
    AppComponent,
    ViewSpeechesComponent,
    SubmitSpeechComponent,
    SearchSpeechesComponent,
    AddSpeechFormComponent,
    AddAuthorFormComponent,
    AuthorSvgComponent,
    EmptySpeechComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RouterModule.forRoot(routes),
    StoreModule.forRoot({
      speech: speechReducer,
    }),
    FormsModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [],
  bootstrap: [AppComponent],
  exports: [RouterModule],
})
export class AppModule {}
